export const localeCodes = ['fr', 'en'] as const
